/**
 * Clickable header row of the Manual Actions bucket card: ReturnGO badge icon, label, total count
 * (always visible, even at 0) and a chevron that reflects the popup's open state. It is the
 * floating-ui reference element, so open/close (click + keyboard) is driven by the trigger props.
 */
import { observer } from "mobx-react";
import { Ref } from "react";
import FontBody2 from "../../../../../../../../../../../components/fonts/font-body2/font-body2";
import IconChevronDown from "../../../../../../../../../../../components/icons/icon-chevron-down/icon-chevron-down";
import IconBucketManualActions from "../../../../../../../../../../../components/icons/icon-bucket-manual-actions/icon-bucket-manual-actions";

interface IProps {
    label: string;
    total: number;
    /** Counters are being recomputed: the previous number stays, dimmed, so the card does not reflow. */
    loading: boolean;
    open: boolean;
    disabled: boolean;
    triggerRef: Ref<HTMLDivElement>;
    triggerProps: Record<string, unknown>;
}

const RmaListManualActionsBucketCardRow: React.FC<IProps> = observer(({ label, total, loading, open, disabled, triggerRef, triggerProps }) => (
    <div
        ref={triggerRef}
        role="button"
        tabIndex={disabled ? -1 : 0}
        className="rma-list-manual-actions-bucket__row"
        {...triggerProps}
    >
        <span className="rma-list-manual-actions-bucket__icon">
            <IconBucketManualActions />
        </span>
        <FontBody2>{label}</FontBody2>
        <span className={`rma-list-manual-actions-bucket__count${loading ? " loading" : ""}`}>{total}</span>
        <span className={`rma-list-manual-actions-bucket__chevron${open ? " open" : ""}`}>
            <IconChevronDown color="var(--color-primary-2-50)" />
        </span>
    </div>
));

export default RmaListManualActionsBucketCardRow;
